// src/utils/dateHelper.js

/**
 * Convert DD-MM-YYYY to YYYY-MM-DD (for input[type="date"])
 * If already in YYYY-MM-DD, returns as it is.
 * Returns empty string for invalid values.
 */

import CryptoJS from "crypto-js";
import { ENCRYPT_SECRET_KEY } from "../apiConfig";

const secretKey = ENCRYPT_SECRET_KEY;

export const formatToInputDate = (dateStr) => {
  if (!dateStr || typeof dateStr !== "string") return "";

  if (!dateStr.includes("-")) return dateStr;

  const parts = dateStr.split("-");

  // Already YYYY-MM-DD
  if (parts[0].length === 4) return dateStr;

  // Convert DD-MM-YYYY → YYYY-MM-DD
  if (parts.length === 3) {
    const [day, month, year] = parts;
    return `${year}-${month}-${day}`;
  }

  return "";
};


/**
 * Convert YYYY-MM-DD to DD-MM-YYYY (for API submit)
 */
export const formatToApiDate = (dateStr) => {
  if (!dateStr || typeof dateStr !== "string") return "";

  // Remove time part if exists
  const dateOnly = dateStr.split(" ")[0];

  const parts = dateOnly.split("-");

  if (parts.length === 3 && parts[0].length === 4) {
    const [year, month, day] = parts;
    return `${day}-${month}-${year}`;
  }

  return dateStr;
};

export const formatDateAge = (dateString) => {
  const [day, month, year] = dateString.split("-");
  return new Date(`${year}-${month}-${day}`);
};


export const calculateAge = (birthDate) => {
  const birthDateObj = new Date(birthDate);
  const today = new Date();
  let age = today.getFullYear() - birthDateObj.getFullYear();
  const monthDiff = today.getMonth() - birthDateObj.getMonth();
  const dayDiff = today.getDate() - birthDateObj.getDate();

  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age--;
  }
  return age;
};

export const encryptData = (data) => {
  return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
}

export const getUserRole = (username) => {
  if (!username) return null;

  const u = username.toLowerCase();
  if (u.includes("cho")) return "CHO";
  if (u.includes("doc")) return "MO";
  if (u.includes("deo")) return "DEO";
  if (u.includes("anm")) return "ANM";
  if (u.includes("nurse")) return "STAFF_NURSE";
  if (u.includes("mpw")) return "MPW";
  return null;
};